import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

const NOTIFICATIONS_ROUTE = "/homepage/notifications";

@Component({
  selector: "adaa-adaa4-stepper",
  imports: [TranslatePipe, RouterLink],
  templateUrl: "./adaa4-stepper.html",
  styleUrl: "./adaa4-stepper.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Adaa4StepperComponent {
  readonly current = input.required<number>();
  readonly notificationId = input<string>();

  readonly steps = computed(() => {
    const id = this.notificationId();
    const steps = [
      { label: "adaa4.notifications_title", link: [NOTIFICATIONS_ROUTE] },
      { label: "adaa4.view_details", link: id ? [NOTIFICATIONS_ROUTE, id] : null },
      { label: "adaa4.action", link: null },
    ];

    return steps.map((step, index) => ({ ...step, number: index + 1, state: this._state(index + 1) }));
  });

  private _state(step: number): "done" | "current" | "todo" {
    if (step < this.current()) return "done";
    return step === this.current() ? "current" : "todo";
  }
}
